module.exports = __webpack_public_path__ + "static/media/ajout-recherche.35c17150.png";